import { parseApiDate } from '~/utils';
import cookies from 'js-cookie';

export const state = () => ({
    procreate: null,
    pocket: null,
})

export const mutations = {
    setProcreate(state, procreate) {
        state.procreate = procreate;
    },
    
    setPocket(state, pocket) {
        state.pocket = pocket;
    },
}

export const actions = {
    async fetchProcreate(context) {
        const country = cookies.get('app-store-country');
        const { data } = await this.$adminApi.get(`/app-store/procreate?only=formattedPrice,currency,country${country ? '&country=' + country : ''}`);
        context.commit('setProcreate', data);
        cookies.set('app-store-country', data.country);
    },

    async fetchPocket(context) {
        const country = cookies.get('app-store-country');
        const { data } = await this.$adminApi.get(`/app-store/pocket?only=formattedPrice,currency,country${country ? '&country=' + country : ''}`);
        context.commit('setPocket', data);
        cookies.set('app-store-country', data.country);
    },
}

export const getters = {
    getProcreate(state) {
        return state.procreate;
    },

    getPocket(state) {
        return state.pocket;
    },
}